import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface RemoveGiftCardFromCartMutationObject {
  mutation: {
    removeGiftCardFromCart: {
      __args: {
        input: {
          cart_id: string
          gift_card_code: string
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const removeGiftCardFromCartMutationObject: RemoveGiftCardFromCartMutationObject = {
  mutation: {
    removeGiftCardFromCart: {
      __args: {
        input: {
          cart_id: '',
          gift_card_code: ''
        }
      }
    }
  }
}

interface RemoveGiftCardFromCartMutationInput {
  cartId: string
  giftCard: string
}

export type RemoveGiftCardFromCartMutation = (input: RemoveGiftCardFromCartMutationInput) => Promise<FetchResult<any>>

export const createRemoveGiftCardFromCartMutation = ({ getMutations, getQueries }: ServiceDependencies): RemoveGiftCardFromCartMutation => async ({ cartId, giftCard }) => {
  const queries = getQueries()
  const mutation = getMutations().removeGiftCardFromCartMutation
  mutation.mutation.removeGiftCardFromCart.__args.input.cart_id = cartId
  mutation.mutation.removeGiftCardFromCart.__args.input.gift_card_code = giftCard
  mutation.mutation.removeGiftCardFromCart = {
    ...mutation.mutation.removeGiftCardFromCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
